import measureUnit from "./measureUnit";
import warehouse from "./warehouse";
import itemGroup from "./itemGroup";
import item from "./item";
import warehouseItem from "./warehouseItem";
import reports from "./reports"
import stockMovement from "./stockMovement";
import transfer from "./transfer";
import goodsIssue from "./goodsIssue";
import stockAdjustment from "./stockAdjustment"
import order from "./order";
import requisition from "./requisition";
import receipt from "./receipt";
export default {
    path: '/warehouse/:warehouseId',
    component: () => import (/* webpackChunkName: "warehouse-layout" */ '../../layouts/WarehouseLayout.vue'),
    meta: { requiresAuth: true },
    children: [
        ...measureUnit,
        ...warehouse,
        ...itemGroup,
        ...item,
        ...warehouseItem,
        ...reports,
        ...stockMovement,
        ...transfer,
        ...goodsIssue,
        ...stockAdjustment,
        ...order,
        ...requisition,
        ...receipt
    ]
}